import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Article from "../components/Article";
import { useNavigate } from "react-router-dom";

const Articles = ({ articles, status }) => {
    const navigate = useNavigate();
  if (status === "loading") {
    // Skeleton Loading State
    return (
      <div className="container space-blog">
        <div className="row">
          {/* Colonne gauche */}
          <div className="col-md-5">
            <h2>
              <Skeleton width="60%" height={30} />
            </h2>
            <p>
              <Skeleton width="90%" height={20} count={3} />
            </p>
          </div>

          {/* Colonne droite */}
          <div className="col-md-7">
            <div className="skeleton-accordion">
              {[...Array(5)].map((_, index) => (
                <div key={index} style={{ marginBottom: "20px" }}>
                  <Skeleton width="80%" height={25} />
                  <Skeleton
                    width="95%"
                    height={15}
                    style={{ marginTop: "10px" }}
                  />
                  <Skeleton
                    width="90%"
                    height={15}
                    style={{ marginTop: "5px" }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Render State
  if (status !== "loading" && articles) {
    return (
      <div className="container space-blog">
        <div className="row bottom-align justify-content-between align-items-center">
          <div className="col-md-6">
            <h2 className="grey500 mb-0">{articles.title}</h2>
            {/* <p>{articles.description}</p> */}
          </div>
          <div className="col-md-6 cta-blue align-right text-end">
            <a href="/blog" className="link-blue">
              Voir tous les articles{" "}
              <img
                src="/images/arrow-right.svg"
                className="arrow ml-8"
                alt="Arrow"
              />
            </a>
          </div>
        </div>
        <div className="row mt-32">
          {articles?.articles?.map((element, index) => (
            <Article
              element={element}
              key={index}
              onClick={() =>
                navigate(`/articles/${element?.slug}`)
              }
            />
          ))}
        </div>
      </div>
    );
  }

  // Fallback
  return null;
};

export default Articles;
